import React from 'react';
import $ from 'jquery';
// import './style/self-test-section.scss';
import SelfTestTemplateMultipleChoiceQuestionContext from './SelfTestTemplateMultipleChoiceQuestionContext';
import { SelfTestQuestion, SelfTestQuestionCollection } from './model/SelfTestQuestion';
import SelfTestTemplateHeadingContext from './SelfTestTemplateHeadingContext';
import { SelfTestAnswers } from './model/SelfTestAnswers';
import { SelfTestResultProps } from './model/SelfTestResultProps';
import { useWindowSize } from '../../core/utils';
import SelfTestTemplateBMIQuestionContext from './SelfTestTemplateBMIQuestionContext';
import SelfTestTemplateDescriptionContext from './SelfTestTemplateDescriptionContext';
import { TrackingService } from '../../core/services/TrackingService';
// import SelfTestTemplateResultContext from './SelfTestTemplateResultContext';

type Props = {
    id: string,
    questions: SelfTestQuestionCollection,
    result: React.FC<SelfTestResultProps>,
}

const SelfTestSection: React.FC<Props> = (props: Props) => {
    const [questIndex, setQuestIndex] = React.useState(null);
    const [pages, setPages] = React.useState<string[]>([]);
    const [answers, setAnswers] = React.useState({} as SelfTestAnswers);

    const renderProgressBar = (index) => {
        if (pages[index] === 'result' || index < props.questions.showProgressBarAfterIndex) {
            $('.self-test__test-progress-bar').hide();
        } else {
            $('.self-test__test-progress-bar').show();
        }
    }

    React.useEffect(() => {
        setQuestIndex(0);
    }, []);

    React.useLayoutEffect(() => {
        const initState: any = $('.self-test__test-question-container').children().map((x, y) => y.id);
        renderProgressBar(0);
        setPages(initState);
    }, []);

    React.useLayoutEffect(() => {
        for (const pg of pages) {
            const $anchor = $(`#${pg}`);
            if (pg === pages[questIndex]) {
                $anchor.addClass('active');
                $anchor.delay(199).fadeIn(200);
            } else {
                $anchor.removeClass('active');
                $anchor.fadeOut(200);
            }
        }
        renderProgressBar(questIndex);
    }, [props.questions, questIndex]);

    const gotoNextQuestion = React.useCallback((answer: string) => {
        const v: SelfTestAnswers = {};
        v[questIndex] = answer;
        const a = {
            ...answers,
            ...v,
        };
        setAnswers(a);

        if(questIndex === 0) {
            TrackingService.trackSelftest(props.questions.analytics.slug, 'start');
        }

        if (questIndex < props.questions.questions.length) {
            setQuestIndex(questIndex + 1);
            if (questIndex + 1 === props.questions.questions.length) {
                // Answer
                if (props.questions.analytics) {
                    TrackingService.trackSelftest(props.questions.analytics.slug, 'result', props.questions.analytics.resultText(a));
                }
            }
        }
    }, [props.questions, questIndex, answers]);

    const clicked = (answer?: string) => {
        gotoNextQuestion(answer ?? "");
    };

    const onReset = () => {
        setQuestIndex(0);
        TrackingService.trackSelftest(props.questions.analytics.slug, 'restart');
        $("html, body").animate({ scrollTop: $('.self-test__test').position()?.top - 150 || 0 }, 600);
    };

    return (
        <section className="self-test__test">
            <div className="self-test__test-question-container">
                {
                    props.questions.questions.map((x, index) => {
                        switch (x.type) {
                            case 'description':
                                return <SelfTestTemplateDescriptionContext id={`${index}`} key={index} q={props.questions.questions[index]} onAnswerClicked={clicked} />
                            case 'multiple-choice':
                                return <SelfTestTemplateMultipleChoiceQuestionContext id={`${index}`} key={index} q={props.questions.questions[index]} onAnswerClicked={clicked} />
                            case 'bmi':
                                return <SelfTestTemplateBMIQuestionContext id={`${index}`} key={index} q={props.questions.questions[index]} onAnswerClicked={clicked} />
                        }
                    })
                }
                <props.result questions={props.questions} answers={answers} onReset={onReset}></props.result>
            </div>
            <div className="self-test__test-progress-bar">
                <div className="self-test__test-progress-bar-container">
                    <ul className="self-test__test-progress-bar-list">
                        <li className={`self-test__test-progress-bar-step ${questIndex >= props.questions.questions.length ? "active" : ""}`}>
                            查看結果
                        </li>
                        {props.questions.questions.map((x, index) => {
                            if (index >= props.questions.showProgressBarAfterIndex) {
                                return (
                                    <li key={index} id={`question-${questIndex}`} className={`self-test__test-progress-bar-step ${questIndex >= index && questIndex >= props.questions.showProgressBarAfterIndex ? "active" : ""}`}>
                                        {x.label}
                                    </li>
                                );
                            }
                        }).reverse()}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default SelfTestSection;
